(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[466],{

/***/ 6751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ Shell; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
;// CONCATENATED MODULE: ./components/molecules/NavBar/styled.ts

var styled_NavBar = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "styled__NavBar",
  componentId: "sc-1pq2k3n-0"
})(["", " > div{", "}a{", "}"], {
  "position": "sticky",
  "zIndex": "10",
  "display": "grid",
  "width": "100%",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "opacity": "0.95",
  "gridTemplateRows": "72px",
  "top": "0",
  "height": "72px",
  "@media (min-width: 1024px)": {
    "scrollSnapAlign": "start"
  }
}, {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "@media (min-width: 1024px)": {
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  }
}, {
  "textDecorationLine": "none"
});
var Logo = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "styled__Logo",
  componentId: "sc-1pq2k3n-1"
})(["", " svg{", " path{fill:url('#custodia-mark_svg__a');}}span{", "}"], {
  "display": "flex",
  "alignItems": "center",
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
}, {
  "height": "2.5rem"
}, {
  "marginLeft": "0.5rem",
  "fontWeight": "700"
});
var NavItemTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__NavItemTitle",
  componentId: "sc-1pq2k3n-2"
})(function (_ref) {
  var isSelected = _ref.isSelected;
  return [{
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))",
    ":hover": {
      "opacity": "0.7"
    }
  }, isSelected && {
    "fontWeight": "700"
  }];
});
var DesktopRightContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__DesktopRightContent",
  componentId: "sc-1pq2k3n-3"
})(["", ""], {
  "display": "flex"
});
var DesktopNavItems = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styled__DesktopNavItems",
  componentId: "sc-1pq2k3n-4"
})(["", ""], {
  "display": "none",
  "listStyleType": "none",
  "gridTemplateColumns": "repeat(3, auto)",
  "alignItems": "center",
  "gap": "3rem",
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem",
  "@media (min-width: 1024px)": {
    "display": "grid"
  }
});
var MobileNavItems = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styled__MobileNavItems",
  componentId: "sc-1pq2k3n-5"
})(function (_ref2) {
  var menuOpen = _ref2.menuOpen;
  return [{
    "display": "none",
    "listStyleType": "none",
    "alignItems": "center",
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem",
    "paddingTop": "1rem",
    "paddingBottom": "1rem",
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "marginTop": "-0.1rem"
  }, {
    "position": "sticky",
    "left": "0px",
    "zIndex": "10",
    "height": "calc(100vh - 72px + 0.1rem)",
    "width": "100%",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
    "top": "72px"
  }, menuOpen && {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "gap": "1.75rem",
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "@media (min-width: 1024px)": {
      "display": "none"
    }
  }];
});
var MobileMenuSpacer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MobileMenuSpacer",
  componentId: "sc-1pq2k3n-6"
})(["", ""], {
  "width": "100%",
  "flexGrow": "1"
});
var MobileSubscribeButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MobileSubscribeButtonWrapper",
  componentId: "sc-1pq2k3n-7"
})(["", " button{", "}"], {
  "width": "100%",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingBottom": "1rem"
}, {
  "display": "block",
  "width": "100%"
});
var DarkModeButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__DarkModeButton",
  componentId: "sc-1pq2k3n-8"
})(["", ""], {
  "marginLeft": "1.5rem",
  "display": "none",
  "@media (min-width: 1024px)": {
    "display": "block"
  }
});
var MenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__MenuButton",
  componentId: "sc-1pq2k3n-9"
})(["", ""], {
  "padding": "0.25rem",
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});
// EXTERNAL MODULE: ../../node_modules/react-icons/vsc/index.mjs
var vsc = __webpack_require__(8097);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./assets/custodia-mark.svg
var custodia_mark = __webpack_require__(5426);
// EXTERNAL MODULE: ./components/molecules/ColoredBorderWrapper/styled.ts
var styled = __webpack_require__(3419);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/molecules/ColoredBorderWrapper/index.tsx




var ColoredBorderWrapper = function ColoredBorderWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(styled/* Border */.O, {})]
  });
};
;// CONCATENATED MODULE: ./components/molecules/NavBar/index.tsx









var ROUTES = [{
  title: 'Avit',
  href: '/avit'
}, {
  title: 'Press',
  href: '/press'
}, {
  title: 'About',
  href: '/about'
}];
var NavBar = function NavBar() {
  var _useState = (0,react.useState)(false),
      menuOpen = _useState[0],
      setMenuOpen = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styled_NavBar, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: '/',
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Logo, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(custodia_mark/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Custodia"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopRightContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MenuButton, {
          onClick: function onClick() {
            return setMenuOpen(!menuOpen);
          },
          "aria-expanded": !!menuOpen,
          "aria-label": "Menu",
          "aria-controls": "nav-menu",
          children: menuOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(vsc/* VscClose */.ven, {
            size: 25
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(vsc/* VscThreeBars */.QEj, {
            size: 25
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DesktopNavItems, {
          children: ROUTES.map(function (r) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(NavItem, {
              href: r.href,
              title: r.title
            }, r.href);
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileNavItems, {
      menuOpen: menuOpen,
      id: 'nav-menu',
      children: [ROUTES.map(function (r) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(NavItem, {
          href: r.href,
          title: r.title
        }, r.href);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MobileMenuSpacer, {})]
    })]
  });
};

var NavItem = function NavItem(_ref) {
  var href = _ref.href,
      title = _ref.title,
      external = _ref.external;
  var router = (0,next_router.useRouter)();
  var isCurrentRoute = !external && (router.route === href || // highlight "Avit" on /avit and any nested page (e.g. the redemption page)
  href === '/avit' && router.route.startsWith('/avit/'));

  var content = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    children: isCurrentRoute ? /*#__PURE__*/(0,jsx_runtime.jsx)(ColoredBorderWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavItemTitle, {
        isSelected: isCurrentRoute,
        children: title
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(NavItemTitle, {
      isSelected: isCurrentRoute,
      children: title
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: external ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: href,
      children: content
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: href,
      children: content
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(2779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/design-system/footer/index.ts + 3 modules
var footer = __webpack_require__(2890);
// EXTERNAL MODULE: ./components/molecules/Shell/styled.ts
var Shell_styled = __webpack_require__(564);
// EXTERNAL MODULE: ./hooks/useIsBrowser.ts
var useIsBrowser = __webpack_require__(9612);
// EXTERNAL MODULE: ../../packages/design-system/cookie-banner/index.tsx + 4 modules
var cookie_banner = __webpack_require__(86);
;// CONCATENATED MODULE: ./components/molecules/Shell/index.tsx










var Shell = function Shell(_ref) {
  var _ref$enableSnapPoints = _ref.enableSnapPoints,
      enableSnapPoints = _ref$enableSnapPoints === void 0 ? false : _ref$enableSnapPoints,
      children = _ref.children;
  var isBrowser = (0,useIsBrowser/* useIsBrowser */.E)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Shell_styled/* ShellWrapper */.r, {
      className: classnames_default()({
        dark: true
      }),
      enableSnapPoints: enableSnapPoints,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Shell_styled/* ContentWrapper */.v, {
        children: children
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(footer/* default */.ZP, {}), isBrowser && /*#__PURE__*/(0,jsx_runtime.jsx)(cookie_banner/* default */.Z, {})]
    })
  });
};

/***/ }),

/***/ 2812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ avit; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/molecules/Seo/index.tsx
var Seo = __webpack_require__(1424);
// EXTERNAL MODULE: ./components/molecules/Shell/index.tsx + 3 modules
var Shell = __webpack_require__(6751);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
;// CONCATENATED MODULE: ./components/screens/avit/styled.ts

// Hero gradient: the "two-tone mesh" (emerald top-left, gold bottom-right) over charcoal.
var HERO_GRADIENT = "radial-gradient(circle at 15% 18%, rgba(65,205,127,0.24), transparent 42%),\n  radial-gradient(circle at 85% 85%, rgba(255,196,37,0.18), transparent 42%),\n  linear-gradient(180deg, #0e120f 0%, #14181a 100%)";
var ScreenWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__ScreenWrapper",
  componentId: "sc-169bdjz-0"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(17 17 17 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
});
var Hero = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styled__Hero",
  componentId: "sc-169bdjz-1"
})(["", " background-image:", ";> h1{", "}> p{", "}"], {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "1.5rem",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingTop": "7rem",
  "paddingBottom": "5rem",
  "textAlign": "center",
  "@media (min-width: 768px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem"
  },
  "@media (min-width: 1024px)": {
    "paddingTop": "9rem"
  }
}, HERO_GRADIENT, {
  "fontFamily": "Lora, serif",
  "fontSize": "3.75rem",
  "lineHeight": "1",
  "--tw-text-opacity": "1",
  "color": "rgb(255 196 37 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "fontSize": "6rem",
    "lineHeight": "1"
  }
}, {
  "maxWidth": "42rem",
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem",
  "--tw-text-opacity": "1",
  "color": "rgb(221 221 221 / var(--tw-text-opacity))",
  "@media (min-width: 768px)": {
    "fontSize": "1.5rem",
    "lineHeight": "2rem"
  }
});
var Mark = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "styled__Mark",
  componentId: "sc-169bdjz-2"
})(["", ""], {
  "height": "auto",
  "width": "150px"
});
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styled__Section",
  componentId: "sc-169bdjz-3"
})(["", " > h2{", "}> p{", "}"], {
  "borderTopWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(68 68 68 / var(--tw-border-opacity))",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingTop": "5rem",
  "paddingBottom": "5rem",
  "@media (min-width: 768px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem"
  }
}, {
  "paddingBottom": "1.5rem",
  "fontFamily": "Lora, serif",
  "fontSize": "1.875rem",
  "lineHeight": "2.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 196 37 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "fontSize": "2.25rem",
    "lineHeight": "2.5rem"
  }
}, {
  "maxWidth": "42rem",
  "fontSize": "1.125rem",
  "lineHeight": "1.75rem",
  "--tw-text-opacity": "1",
  "color": "rgb(221 221 221 / var(--tw-text-opacity))",
  "@media (min-width: 768px)": {
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem"
  }
}); // "What is AVIT?" two-column layout: explainer body (left) + whitepaper callout card (right).

var Split = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Split",
  componentId: "sc-169bdjz-4"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column",
  "gap": "2rem",
  "@media (min-width: 768px)": {
    "flexDirection": "row",
    "alignItems": "flex-start",
    "gap": "3rem"
  }
});
var SplitMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__SplitMain",
  componentId: "sc-169bdjz-5"
})(["", " > p{", "}"], {
  "flex": "1 1 0%"
}, {
  "fontSize": "1.125rem",
  "lineHeight": "1.75rem",
  "--tw-text-opacity": "1",
  "color": "rgb(221 221 221 / var(--tw-text-opacity))",
  "@media (min-width: 768px)": {
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem"
  }
});
var Aside = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Aside",
  componentId: "sc-169bdjz-6"
})(["", " > h3{", "}> p{", "}"], {
  "width": "100%",
  "flexShrink": "0",
  "borderRadius": "0.375rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(85 85 85 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(34 34 34 / var(--tw-bg-opacity))",
  "padding": "1.5rem",
  "@media (min-width: 768px)": {
    "width": "20rem"
  }
}, {
  "paddingBottom": "0.5rem",
  "fontFamily": "Lora, serif",
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 196 37 / var(--tw-text-opacity))"
}, {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(221 221 221 / var(--tw-text-opacity))"
});
var CtaLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "styled__CtaLink",
  componentId: "sc-169bdjz-7"
})(["", ""], {
  "marginTop": "1.5rem",
  "display": "inline-block",
  "borderRadius": "0.375rem",
  "borderWidth": "2px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(255 196 37 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 196 37 / var(--tw-bg-opacity))",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem",
  "textTransform": "uppercase",
  "letterSpacing": "0.2rem",
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 0 / var(--tw-text-opacity))",
  "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms",
  ":hover": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(255 213 77 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 213 77 / var(--tw-bg-opacity))"
  }
});
var ContractLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "styled__ContractLink",
  componentId: "sc-169bdjz-8"
})(["", ""], {
  "marginTop": "1.5rem",
  "display": "block",
  "overflowWrap": "break-word",
  "fontSize": "1.125rem",
  "lineHeight": "1.75rem",
  "--tw-text-opacity": "1",
  "color": "rgb(65 205 127 / var(--tw-text-opacity))",
  "textDecorationLine": "underline"
});
var MetricsGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MetricsGrid",
  componentId: "sc-169bdjz-9"
})(["", ""], {
  "marginTop": "1.5rem",
  "display": "grid",
  "maxWidth": "48rem",
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))",
  "gap": "1rem",
  "@media (min-width: 640px)": {
    "gridTemplateColumns": "repeat(3, minmax(0, 1fr))"
  }
});
var Metric = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Metric",
  componentId: "sc-169bdjz-10"
})(["", ""], {
  "borderRadius": "0.375rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(85 85 85 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(34 34 34 / var(--tw-bg-opacity))",
  "padding": "1.5rem"
});
var MetricValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MetricValue",
  componentId: "sc-169bdjz-11"
})(["", ""], {
  "fontFamily": "Lora, serif",
  "fontSize": "1.875rem",
  "lineHeight": "2.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 196 37 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "fontSize": "2.25rem",
    "lineHeight": "2.5rem"
  }
});
var MetricLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MetricLabel",
  componentId: "sc-169bdjz-12"
})(["", ""], {
  "marginTop": "0.5rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "textTransform": "uppercase",
  "letterSpacing": "0.2rem",
  "--tw-text-opacity": "1",
  "color": "rgb(151 151 151 / var(--tw-text-opacity))"
});
var AsOf = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styled__AsOf",
  componentId: "sc-169bdjz-13"
})(["", " color:#979797 !important;"], {
  "marginTop": "1rem",
  "fontSize": "0.75rem",
  "lineHeight": "1rem",
  "fontStyle": "italic"
}); // AVIT terms notice. Body text is the verbatim Cleary-cleared language; the inline
// link points to the production AvitToken proxy on Blockscout.

var Terms = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styled__Terms",
  componentId: "sc-169bdjz-14"
})(["", " > h2{", "}> p{", "}a{", "}"], {
  "borderTopWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(68 68 68 / var(--tw-border-opacity))",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingTop": "3rem",
  "paddingBottom": "3rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(151 151 151 / var(--tw-text-opacity))",
  "@media (min-width: 768px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem"
  }
}, {
  "paddingBottom": "1.5rem",
  "fontFamily": "Lora, serif",
  "fontSize": "1.875rem",
  "lineHeight": "2.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 196 37 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "fontSize": "2.25rem",
    "lineHeight": "2.5rem"
  }
}, {
  "maxWidth": "48rem",
  "lineHeight": "1.625"
}, {
  "wordBreak": "break-all",
  "--tw-text-opacity": "1",
  "color": "rgb(65 205 127 / var(--tw-text-opacity))",
  "textDecorationLine": "underline"
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/screens/avit/index.tsx


 // Hidden pending live data — re-enable with the reserve metrics / attestations /
// redemption sections below (sc-41623).
// import { AttestationList } from '~/components/molecules/AttestationList'
// import { useReserveMetrics } from './useReserveMetrics'

/*
const usd = (n: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    maximumFractionDigits: 2,
  }).format(n)

const compact = (n: number) =>
  new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 2,
  }).format(n)

const pct = (ratio: number) => `${(ratio * 100).toFixed(1)}%`

const asOfLabel = (iso: string) =>
  new Date(iso).toLocaleString('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short',
  })
*/
// AVIT landing page. Design "3b": two-tone mesh hero gradient + blue→green→gold mark.



var Screen = function Screen() {
  // const { data, status } = useReserveMetrics()
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Shell/* Shell */.N, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ScreenWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Hero, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Mark, {
          src: "/images/avit/avit.png",
          alt: "Avit"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          children: "Avit"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "A programmatically compliant, bank-issued token pegged 1:1 to the US dollar. A tokenized deposit within the Hazel Network, designed to be a GENIUS Act regulated payment stablecoin beyond it."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: "What is Avit?"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Split, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SplitMain, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Avit is Hazel Network's unified token. A single, integrated smart contract issues Avit as a tokenized deposit when held within the consortium of banks, and as a stablecoin designed to comply with the GENIUS Act, redeemable one-to-one for a US dollar when held by anyone else. The legal character changes automatically at the consortium boundary, and reserve requirements are enforced at the protocol level."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContractLink, {
              href: 'https://eth.blockscout.com/address/0xCcdc193AcF86160dDC79E20F7e471e53f2AF8Ecb?tab=index',
              target: '_blank',
              rel: 'noopener noreferrer',
              children: "View the Avit contract on mainnet"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Aside, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              children: "Want to learn more?"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "The Hazel Network white paper covers the full design."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CtaLink, {
              href: '/Hazel-Network-White-Paper.pdf',
              target: '_blank',
              rel: 'noopener noreferrer',
              children: "Read the white paper"
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Terms, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: "Avit Terms"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          children: ["The terms of each Avit transferable record can be found in the source code for each Avit, which can be found in the source code of the implementation contract (via the proxy contract) located here:", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: 'https://eth.blockscout.com/address/0xdA3d14B7De411609D166ADcb8EA623CC74A21E82?tab=contract',
            target: '_blank',
            rel: 'noopener noreferrer',
            children: "https://eth.blockscout.com/address/0xdA3d14B7De411609D166ADcb8EA623CC74A21E82?tab=contract"
          }), ". As further described in such terms, each Avit is a transferable record pursuant to Section 16 of the Uniform Electronic Transactions Act, pursuant to which Custodia unconditionally promises to pay a holder one (1) U.S. dollar to redeem one (1) Avit on demand. Custodia is at all times subject to applicable Law, including, without limitation, that any Avit may be forfeited or subject to forfeiture to, or seizure by, a law enforcement agency, if the Avit has been or is being used for illegal activity or is subject to a legal order or other process, and that any Avit subject to such forfeiture or seizure, or that is otherwise subject to freezing or any similar limitation or use, may be wholly and permanently unrecoverable and unusable and may, in appropriate circumstances, be destroyed. For more information, please refer to the terms of each Avit located in its source code."]
        })]
      })]
    })
  });
};
// EXTERNAL MODULE: ./config/index.ts
var config = __webpack_require__(9597);
;// CONCATENATED MODULE: ./pages/avit.tsx








var Page = function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Seo/* Seo */.p, {
      title: "Avit | ".concat(config/* site.title */.l.title),
      description: 'Avit is a programmatically compliant, bank-issued token pegged 1:1 to the US dollar: a tokenized deposit within the Hazel Network, designed to be a GENIUS Act regulated payment stablecoin beyond it.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Screen, {})]
  });
};

/* harmony default export */ var avit = (Page);

/***/ }),

/***/ 2656:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avit",
      function () {
        return __webpack_require__(2812);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [946,250,456,774,888,179], function() { return __webpack_exec__(2656); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);